// extracted by mini-css-extract-plugin
export default {"header":"style_header__jkLPz","subheader":"style_subheader__0jbmL","numbers":"style_numbers__1zKIy"};